import axios from 'axios';
import React, { useEffect, useState } from 'react';
import localStorage from '../../utils/localStorage';
import { API_DEVICE, MASTER } from '../../commons/api';
import { Button, Input, Modal, Select, Tree } from 'antd';
import { DownloadOutlined, UpSquareOutlined } from '@ant-design/icons';

const { Option } = Select;

const { TreeNode } = Tree;
const SelectComponent = (props) => {
 
//const [initalRender,setInitialRender] = useState(true);
const [hierarchyData,setHierarchyData] = useState([]);
const [isModalVisible,setIsModalVisible] =  useState(false);
const [deviceList,setDeviceList] = useState([]);
const [,setColumn] = useState(null);
const [,setOptionList] = useState(null);

 
useEffect(() => {
   setColumn(props.column);
},[props.column]);

useEffect(() => {
  let column = props;
    _getOptionList(column);
    // if (column && column.type && column.type === 'Hierarchy') {
    getDashboardData();
},[]);
  
  const getDashboardData = async () => {
    let deviceList = await _getDevicesList();
    setDeviceList(deviceList);
  };

  const _getDevicesList = () => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const ObjectHeader = {
      method: 'GET',
      url: `${API_DEVICE.GET}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(ObjectHeader)
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return [];
      });
  };

  // const renameProperty = (obj, oldName1, newName1, oldName2, newName2) => {
  //   if (obj && obj.children) {
  //     let children = obj.children.map((objChildren) => {
  //       return renameProperty(objChildren, oldName1, newName1, oldName2, newName2);
  //     });
  //     obj['children'] = children;
  //     obj[newName1] = obj[oldName1];
  //     delete obj[oldName1];
  //     obj[newName2] = obj[oldName2];
  //     delete obj[oldName2];
  //     return obj;
  //   } else {
  //     obj[newName1] = obj[oldName1];
  //     delete obj[oldName1];
  //     obj[newName2] = obj[oldName2];
  //     delete obj[oldName2];
  //     return obj;
  //   }
  // };

 const getDevicesList = (payload) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    let url = '';
    if (payload && payload.method === 'GET' && payload.GETParams) {
      url = `${payload.url}?SiteId=${siteId}${payload.GETParams}`;
    } else {
      url = `${payload.url}?SiteId=${siteId}`;
    }
    let payloadData = payload && payload.payload ? payload.payload : '';
    const ObjectHeader = {
      method: payload.method,
      url,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payloadData || {}
    };
    return axios(ObjectHeader)
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return [];
      });
  };

  const _getOptionList = async () => {
    let { column, initalRender } = props;
    if (column && column.type && column.type === 'Hierarchy') {
      // const userData = JSON.parse(localStorage.get('modules'));
      let hierarchydata = await getDevicesList(column.payload, 'hierachy');  //changed the hierarchydata to hierarchyData
      //let hierarchydata = []
      let hierarchyData = hierarchydata.map((userHierarchy) => {
        return this.renameProperty(userHierarchy, 'Name', 'title', 'key', 'key');
      });
      setHierarchyData(hierarchyData);
    } else {
      const siteId = localStorage.get('currentSite');
      const accessToken = localStorage.get('accessToken');
      let objectHeader = {};
      if (column && column.table && Array.isArray(column.table)) {
        setOptionList(column.table);
        return column.table;
      }
      if (column && column.table && column.table.url && !column.table.method) {
        objectHeader = {
          method: 'GET',
          url: `${column.table.url}&SiteId=${siteId}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        };
      } else if (
        column &&
        column.table &&
        column.table.url &&
        column.table.method &&
        column.table.payload &&
        column.table.method === 'POST'
      ) {
        objectHeader = {
          method: column.table.method,
          url: `${column.table.url}?SiteId=${siteId}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: column.table.payload
        };
      } else {
        objectHeader = {
          method: 'POST',
          url: `${MASTER.DropDown}?SiteId=${siteId}`,
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
          data: {
            tableName: column.table
          }
        };
      }
      return axios(objectHeader)
        .then((response) => {
          if (Array.isArray(response.data)) {
            let optionList = response.data;
           setOptionList(optionList);
            if (
              optionList[0] &&
              column.option &&
              column.option.value &&
              initalRender &&
              initalRender === true
            ) {
                props.handleFieldChange(
                optionList[0][column.option.value],
                {
                  optionList,
                  initalRender: false
                },
                column
              );
            }
          }
        })
        .catch(() => {
          return [];
        });
    }
  };
  const getData = (DeviceCode) => {
    let { column, optionList } = props;
    props.handleFieldChange(
      DeviceCode,
      {
        optionList,
        initalRender: false
      },
      column
    );
  };

  const renderTreeNodes = (data) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item.children && item.children.length > 0) {
          return (
            <TreeNode
              title={
                <div
                // onClick={() => this.getData(item)}
                >
                  {item.Name}
                </div>
              }
              key={item.key}
              dataRef={item}
            >
              {renderTreeNodes(item.children)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            key={item.key}
            title={
              <div
                onClick={() => {
                  getData(item.key);
                }}
              >
                {item.Name}
              </div>
            }
            dataRef={item}
          />
        );
      })
    );
  };


    let { column, record, optionList } = props;
    let filteredDevice =
      column && column.defaultValue && deviceList && Array.isArray(deviceList)
        ? deviceList.filter((device) => device.DeviceCode === column.defaultValue)
        : [];

    return (
      <div>
        {column && column.type && column.type !== 'Hierarchy' ? (
          <div>
            <span style={{ fontWeight: 'bold', color: 'white' }}>{column.Name}</span>
            <Select
              value={column && column.defaultValue ? column.defaultValue : ''}
              //  defaultValue={optionList && optionList[0] && optionList[0].Name ? optionList[0].Name : ""}
              style={{ width: 320, margin: '0px 5px' }}
              onChange={(e) => {
                props.handleFieldChange(
                  e,
                  {
                    optionList,
                    initalRender: false
                  },
                  column
                );
              }}
              onKeyPress={(e) => props.handleKeyPress(e, record.key)}
              placeholder={column.placeHolder || column.displayName}
            >
              {optionList &&
                optionList.map((data, index) => {
                  if (
                    column &&
                    column.option &&
                    column.option.display &&
                    column.option.value &&
                    data[column.option.value] &&
                    data[column.option.display]
                  ) {
                    return (
                      <Option key={index} value={data[column.option.value]}>
                        {data[column.option.display]}
                      </Option>
                    );
                  }
                  return (
                    <Option key={index} value={data}>
                      {data}
                    </Option>
                  );
                })}
            </Select>
          </div>
        ) : (
          <span
            style={{
              height: '40px',
              display: 'flex',
              justifyContent: 'flex-start',
              flexFlow: 'row wrap',
              marginTop: '10px'
            }}
          >
            <Input
              // value={column && column.defaultValue ? column.defaultValue : ''}
              value={
                filteredDevice &&
                  Array.isArray(filteredDevice) &&
                  filteredDevice[0] &&
                  filteredDevice[0].Name
                  ? `${filteredDevice[0].AssetName ? filteredDevice[0].AssetName : ''}${filteredDevice[0].Name ? `::${filteredDevice[0].Name}` : ''
                  }  `
                  : ''
              }
              
              style={{ width: 300, opacity: 1, height: '32px' }}
            />
            <Button
              type="primary"
              style={{ marginRight: '5px' }}
              onClick={() => {
                setIsModalVisible(!isModalVisible);
              }}
            >
              <UpSquareOutlined />
            </Button>
            <Modal
              title={'Select Hierarchy'}
              className="hierarchyModal"
              open={isModalVisible}
              bodyStyle={{ overflowY: 'scroll', height: '900px' }}
              footer={null}
              onCancel={() => {
                setIsModalVisible(false);
              }}
            >
              <div style={{ height: '70%', marginTop: '10px' }}>
                <Tree
                  showLine
                  defaultExpandAll={true}
                  switcherIcon={<DownloadOutlined />}
                 // onExpand={onExpand}
                  value={column.defaultValue ? [column.defaultValue] : ''}
                >
                  {renderTreeNodes(hierarchyData)}
                </Tree>
              </div>
            </Modal>
          </span>
        )}
      </div>
    );
  };


export default SelectComponent;
